// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16-KR","clinicsSelect":"styles_clinicsSelect__1sGX7"};